import { DefaultQueryParams, parseQuery, resizeGame } from '@pascal/pascal-core';
import { BET_SHOP_GAME_ID } from '../enums/constants';

// const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
// const isBetShop = +gameId === BET_SHOP_GAME_ID;

let maxHeight = 846; // isBetShop ? 700 :
let maxWidth = 1500; // isBetShop ? 1196 :

const target = document.querySelector('.root');
export const resizeGameHandler = () => {
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
  const isBetShop = +gameId === BET_SHOP_GAME_ID;
  if (isBetShop) {
    maxHeight = 1080;
    maxWidth = 1920;
  }
  resizeGame(maxHeight, maxWidth, target);
};
